module.exports = __webpack_public_path__ + "img/video.095f23c6.svg";